export default __webpack_public_path__ + "static/media/type_10_4.9ae859da.svg";